import { render, staticRenderFns } from "./UserNotifications.vue?vue&type=template&id=3a382d93&scoped=true&"
import script from "./UserNotifications.vue?vue&type=script&lang=js&"
export * from "./UserNotifications.vue?vue&type=script&lang=js&"
import style0 from "./UserNotifications.vue?vue&type=style&index=0&id=3a382d93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a382d93",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a382d93')) {
      api.createRecord('3a382d93', component.options)
    } else {
      api.reload('3a382d93', component.options)
    }
    module.hot.accept("./UserNotifications.vue?vue&type=template&id=3a382d93&scoped=true&", function () {
      api.rerender('3a382d93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserNotifications.vue"
export default component.exports